export default __webpack_public_path__ + "static/media/parking.c55953df.svg";